import React from 'react';

import Dialog from '../../shared/PFDialog/PFDialogContainer';

import UserSettingsContainer from './UserSettingsContainer';

const UserSettingsDialog = ({
  showDialog,
  handleCloseDialogue,
  defaultTabIndex,
}) => {
  const handleDialog = value => {
    handleCloseDialogue(value ? value : false);
    localStorage.removeItem('wantSetupMpin');
  };
  return (
    <Dialog
      header="User Settings"
      visible={showDialog}
      className="w-11 lg:w-7 xl:w-5 min-vh-50"
      onHide={() => handleDialog()}
      draggable={false}
    >
      <UserSettingsContainer
        defaultTabIndex={defaultTabIndex}
        handleCloseDialogue={handleCloseDialogue}
      />
    </Dialog>
  );
};

export default UserSettingsDialog;
